import { take } from 'lib/array/arrayUtils'
import dedupeConcat from 'lib/array/arrayConcatDedupe'
import {
  set as setLocalStorage,
  get as getLocalStorage,
} from 'lib/storage/isomorphicLocalStorage'
const LOCAL_STORAGE_RECENTLY_VIEWED_OFFERS_KEY = 'recentlyViewedOffers'

export function getRecentlyViewedOffersFromLocal(): Array<App.RecentlyViewedOffer> {
  const recents = getLocalStorage(LOCAL_STORAGE_RECENTLY_VIEWED_OFFERS_KEY) as Array<App.RecentlyViewedOffer> | undefined
  if (!recents) {
    return []
  }
  return recents
}

export function saveRecentlyViewedOffersToLocal(recents: Array<App.RecentlyViewedOffer>) {
  const localArray = getRecentlyViewedOffersFromLocal()
  const recentsArray = take(dedupeConcat(recents, localArray, (val) => val.offerId), 10)
  setLocalStorage(LOCAL_STORAGE_RECENTLY_VIEWED_OFFERS_KEY, recentsArray)
}

export function removeRecentlyViewedOffersFromLocal(offerId: Array<string>) {
  const localArray = getRecentlyViewedOffersFromLocal()
  const recentsArray = localArray.filter(offer => !offerId.includes(offer.offerId))
  setLocalStorage(LOCAL_STORAGE_RECENTLY_VIEWED_OFFERS_KEY, recentsArray)
}
